'use strict';

runBlock.$inject = ["$rootScope", "AppSettings", "gettextCatalog", "$state", "$log", "$transitions", "$window"];
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
var cov_2oqhyj6108 = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/index.js',
        hash = 'c682643219a7d553473428365d5453175a53cb85',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/index.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 13,
                    column: 19
                }
            },
            '1': {
                start: {
                    line: 17,
                    column: 4
                },
                end: {
                    line: 17,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 19,
                    column: 4
                },
                end: {
                    line: 19,
                    column: 32
                }
            },
            '3': {
                start: {
                    line: 21,
                    column: 4
                },
                end: {
                    line: 21,
                    column: 27
                }
            },
            '4': {
                start: {
                    line: 23,
                    column: 4
                },
                end: {
                    line: 23,
                    column: 31
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 4
                },
                end: {
                    line: 24,
                    column: 33
                }
            },
            '6': {
                start: {
                    line: 26,
                    column: 4
                },
                end: {
                    line: 26,
                    column: 53
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 30
                },
                end: {
                    line: 26,
                    column: 52
                }
            },
            '8': {
                start: {
                    line: 28,
                    column: 19
                },
                end: {
                    line: 34,
                    column: 5
                }
            },
            '9': {
                start: {
                    line: 36,
                    column: 14
                },
                end: {
                    line: 36,
                    column: 57
                }
            },
            '10': {
                start: {
                    line: 38,
                    column: 4
                },
                end: {
                    line: 38,
                    column: 33
                }
            },
            '11': {
                start: {
                    line: 40,
                    column: 4
                },
                end: {
                    line: 40,
                    column: 55
                }
            },
            '12': {
                start: {
                    line: 42,
                    column: 4
                },
                end: {
                    line: 49,
                    column: 6
                }
            },
            '13': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 9
                }
            },
            '14': {
                start: {
                    line: 44,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 35
                }
            },
            '15': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 46,
                    column: 35
                }
            },
            '16': {
                start: {
                    line: 48,
                    column: 8
                },
                end: {
                    line: 48,
                    column: 59
                }
            },
            '17': {
                start: {
                    line: 51,
                    column: 4
                },
                end: {
                    line: 112,
                    column: 7
                }
            },
            '18': {
                start: {
                    line: 52,
                    column: 8
                },
                end: {
                    line: 52,
                    column: 38
                }
            },
            '19': {
                start: {
                    line: 53,
                    column: 8
                },
                end: {
                    line: 53,
                    column: 31
                }
            },
            '20': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 36
                }
            },
            '21': {
                start: {
                    line: 55,
                    column: 8
                },
                end: {
                    line: 55,
                    column: 38
                }
            },
            '22': {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '23': {
                start: {
                    line: 58,
                    column: 12
                },
                end: {
                    line: 58,
                    column: 59
                }
            },
            '24': {
                start: {
                    line: 59,
                    column: 12
                },
                end: {
                    line: 59,
                    column: 47
                }
            },
            '25': {
                start: {
                    line: 60,
                    column: 12
                },
                end: {
                    line: 60,
                    column: 55
                }
            },
            '26': {
                start: {
                    line: 61,
                    column: 12
                },
                end: {
                    line: 61,
                    column: 42
                }
            },
            '27': {
                start: {
                    line: 62,
                    column: 12
                },
                end: {
                    line: 62,
                    column: 41
                }
            },
            '28': {
                start: {
                    line: 63,
                    column: 12
                },
                end: {
                    line: 63,
                    column: 39
                }
            },
            '29': {
                start: {
                    line: 64,
                    column: 12
                },
                end: {
                    line: 64,
                    column: 38
                }
            },
            '30': {
                start: {
                    line: 65,
                    column: 15
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '31': {
                start: {
                    line: 66,
                    column: 12
                },
                end: {
                    line: 66,
                    column: 54
                }
            },
            '32': {
                start: {
                    line: 67,
                    column: 12
                },
                end: {
                    line: 67,
                    column: 53
                }
            },
            '33': {
                start: {
                    line: 68,
                    column: 12
                },
                end: {
                    line: 68,
                    column: 47
                }
            },
            '34': {
                start: {
                    line: 69,
                    column: 12
                },
                end: {
                    line: 69,
                    column: 42
                }
            },
            '35': {
                start: {
                    line: 70,
                    column: 12
                },
                end: {
                    line: 70,
                    column: 38
                }
            },
            '36': {
                start: {
                    line: 71,
                    column: 15
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '37': {
                start: {
                    line: 72,
                    column: 12
                },
                end: {
                    line: 72,
                    column: 55
                }
            },
            '38': {
                start: {
                    line: 73,
                    column: 12
                },
                end: {
                    line: 73,
                    column: 53
                }
            },
            '39': {
                start: {
                    line: 74,
                    column: 12
                },
                end: {
                    line: 74,
                    column: 47
                }
            },
            '40': {
                start: {
                    line: 75,
                    column: 12
                },
                end: {
                    line: 75,
                    column: 42
                }
            },
            '41': {
                start: {
                    line: 76,
                    column: 12
                },
                end: {
                    line: 76,
                    column: 44
                }
            },
            '42': {
                start: {
                    line: 77,
                    column: 15
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '43': {
                start: {
                    line: 78,
                    column: 12
                },
                end: {
                    line: 78,
                    column: 55
                }
            },
            '44': {
                start: {
                    line: 79,
                    column: 12
                },
                end: {
                    line: 79,
                    column: 53
                }
            },
            '45': {
                start: {
                    line: 80,
                    column: 12
                },
                end: {
                    line: 80,
                    column: 47
                }
            },
            '46': {
                start: {
                    line: 81,
                    column: 12
                },
                end: {
                    line: 81,
                    column: 42
                }
            },
            '47': {
                start: {
                    line: 82,
                    column: 12
                },
                end: {
                    line: 82,
                    column: 46
                }
            },
            '48': {
                start: {
                    line: 83,
                    column: 15
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '49': {
                start: {
                    line: 84,
                    column: 12
                },
                end: {
                    line: 84,
                    column: 55
                }
            },
            '50': {
                start: {
                    line: 85,
                    column: 12
                },
                end: {
                    line: 85,
                    column: 53
                }
            },
            '51': {
                start: {
                    line: 86,
                    column: 12
                },
                end: {
                    line: 86,
                    column: 47
                }
            },
            '52': {
                start: {
                    line: 87,
                    column: 12
                },
                end: {
                    line: 87,
                    column: 41
                }
            },
            '53': {
                start: {
                    line: 88,
                    column: 15
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '54': {
                start: {
                    line: 89,
                    column: 12
                },
                end: {
                    line: 89,
                    column: 55
                }
            },
            '55': {
                start: {
                    line: 90,
                    column: 12
                },
                end: {
                    line: 90,
                    column: 53
                }
            },
            '56': {
                start: {
                    line: 91,
                    column: 12
                },
                end: {
                    line: 91,
                    column: 47
                }
            },
            '57': {
                start: {
                    line: 92,
                    column: 12
                },
                end: {
                    line: 92,
                    column: 42
                }
            },
            '58': {
                start: {
                    line: 93,
                    column: 12
                },
                end: {
                    line: 93,
                    column: 42
                }
            },
            '59': {
                start: {
                    line: 94,
                    column: 15
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '60': {
                start: {
                    line: 95,
                    column: 12
                },
                end: {
                    line: 95,
                    column: 55
                }
            },
            '61': {
                start: {
                    line: 96,
                    column: 12
                },
                end: {
                    line: 96,
                    column: 53
                }
            },
            '62': {
                start: {
                    line: 97,
                    column: 12
                },
                end: {
                    line: 97,
                    column: 47
                }
            },
            '63': {
                start: {
                    line: 98,
                    column: 12
                },
                end: {
                    line: 98,
                    column: 42
                }
            },
            '64': {
                start: {
                    line: 99,
                    column: 12
                },
                end: {
                    line: 99,
                    column: 43
                }
            },
            '65': {
                start: {
                    line: 100,
                    column: 15
                },
                end: {
                    line: 111,
                    column: 9
                }
            },
            '66': {
                start: {
                    line: 101,
                    column: 12
                },
                end: {
                    line: 101,
                    column: 55
                }
            },
            '67': {
                start: {
                    line: 102,
                    column: 12
                },
                end: {
                    line: 102,
                    column: 53
                }
            },
            '68': {
                start: {
                    line: 103,
                    column: 12
                },
                end: {
                    line: 103,
                    column: 47
                }
            },
            '69': {
                start: {
                    line: 104,
                    column: 12
                },
                end: {
                    line: 104,
                    column: 42
                }
            },
            '70': {
                start: {
                    line: 105,
                    column: 12
                },
                end: {
                    line: 105,
                    column: 45
                }
            },
            '71': {
                start: {
                    line: 107,
                    column: 12
                },
                end: {
                    line: 107,
                    column: 53
                }
            },
            '72': {
                start: {
                    line: 108,
                    column: 12
                },
                end: {
                    line: 108,
                    column: 47
                }
            },
            '73': {
                start: {
                    line: 109,
                    column: 12
                },
                end: {
                    line: 109,
                    column: 55
                }
            },
            '74': {
                start: {
                    line: 110,
                    column: 12
                },
                end: {
                    line: 110,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 16,
                        column: 9
                    },
                    end: {
                        line: 16,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 96
                    },
                    end: {
                        line: 113,
                        column: 1
                    }
                },
                line: 16
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 26,
                        column: 24
                    },
                    end: {
                        line: 26,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 30
                    },
                    end: {
                        line: 26,
                        column: 52
                    }
                },
                line: 26
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 42,
                        column: 28
                    },
                    end: {
                        line: 42,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 34
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 42
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 51,
                        column: 29
                    },
                    end: {
                        line: 51,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 51,
                        column: 52
                    },
                    end: {
                        line: 112,
                        column: 5
                    }
                },
                line: 51
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 47,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 47,
                        column: 9
                    }
                }, {
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 47,
                        column: 9
                    }
                }],
                line: 43
            },
            '1': {
                loc: {
                    start: {
                        line: 57,
                        column: 8
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 57,
                        column: 8
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 57,
                        column: 8
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 57
            },
            '2': {
                loc: {
                    start: {
                        line: 65,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 65,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 65,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 65
            },
            '3': {
                loc: {
                    start: {
                        line: 71,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 71,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 71,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 71
            },
            '4': {
                loc: {
                    start: {
                        line: 77,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 77,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 77,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 77
            },
            '5': {
                loc: {
                    start: {
                        line: 83,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 83,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 83,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 83
            },
            '6': {
                loc: {
                    start: {
                        line: 88,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 88,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 88,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 88
            },
            '7': {
                loc: {
                    start: {
                        line: 94,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 94,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 94,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 94
            },
            '8': {
                loc: {
                    start: {
                        line: 100,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 100,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }, {
                    start: {
                        line: 100,
                        column: 15
                    },
                    end: {
                        line: 111,
                        column: 9
                    }
                }],
                line: 100
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0,
            '70': 0,
            '71': 0,
            '72': 0,
            '73': 0,
            '74': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2oqhyj6108.s[0]++;
angular.module('app', ['ui.router', 'ngMaterial', 'gettext', 'youtube-embed', 'viewhead'])
/* eslint-disable no-undef */
.constant('AppSettings', {
    appUrl: 'https://circo.soloweb.pt'
}).run(runBlock);

/** @ngInject */
function runBlock($rootScope, AppSettings, gettextCatalog, $state, $log, $transitions, $window) {
    cov_2oqhyj6108.f[0]++;
    cov_2oqhyj6108.s[1]++;

    $rootScope.AppSettings = AppSettings;

    cov_2oqhyj6108.s[2]++;
    $rootScope.menuOpen = false;

    cov_2oqhyj6108.s[3]++;
    $rootScope.lang = 'pt';

    cov_2oqhyj6108.s[4]++;
    $rootScope.showFeed = true;
    cov_2oqhyj6108.s[5]++;
    $rootScope.fullHeader = true;

    cov_2oqhyj6108.s[6]++;
    $rootScope.goBack = function () {
        cov_2oqhyj6108.f[1]++;
        cov_2oqhyj6108.s[7]++;
        return $window.history.back();
    };

    var themes = (cov_2oqhyj6108.s[8]++, [{ dark: '#ff9900', light: '#FBC785' }, { dark: '#ff3399', light: '#FFF5FB' }, { dark: '#993399', light: '#FAF5FB' }, { dark: '#00cccc', light: '#F3FBFE' }, { dark: '#0066cc', light: '#F3F8FC' }]);

    var i = (cov_2oqhyj6108.s[9]++, Math.floor(Math.random() * themes.length));

    cov_2oqhyj6108.s[10]++;
    $rootScope.theme = themes[i];

    cov_2oqhyj6108.s[11]++;
    gettextCatalog.setCurrentLanguage($rootScope.lang);

    cov_2oqhyj6108.s[12]++;
    $rootScope.changeLang = function () {
        cov_2oqhyj6108.f[2]++;
        cov_2oqhyj6108.s[13]++;

        if ($rootScope.lang == 'en') {
            cov_2oqhyj6108.b[0][0]++;
            cov_2oqhyj6108.s[14]++;

            $rootScope.lang = 'pt';
        } else {
            cov_2oqhyj6108.b[0][1]++;
            cov_2oqhyj6108.s[15]++;

            $rootScope.lang = 'en';
        }
        cov_2oqhyj6108.s[16]++;
        gettextCatalog.setCurrentLanguage($rootScope.lang);
    };

    cov_2oqhyj6108.s[17]++;
    $transitions.onEnter({}, function (transition, state) {
        cov_2oqhyj6108.f[3]++;
        cov_2oqhyj6108.s[18]++;

        $rootScope.fullHeader = false;
        cov_2oqhyj6108.s[19]++;
        $rootScope.filter = {};
        cov_2oqhyj6108.s[20]++;
        $rootScope.menuOpen = false;
        cov_2oqhyj6108.s[21]++;
        $rootScope.hideScroll = false;

        cov_2oqhyj6108.s[22]++;
        if (state.name === 'home') {
            cov_2oqhyj6108.b[1][0]++;
            cov_2oqhyj6108.s[23]++;

            $rootScope.menuBackgroundColor = 'transparent';
            cov_2oqhyj6108.s[24]++;
            $rootScope.menuTextColor = 'white';
            cov_2oqhyj6108.s[25]++;
            $rootScope.showSecondaryNavigation = false;
            cov_2oqhyj6108.s[26]++;
            $rootScope.backButton = false;
            cov_2oqhyj6108.s[27]++;
            $rootScope.fullHeader = true;
            cov_2oqhyj6108.s[28]++;
            $rootScope.showFeed = true;
            cov_2oqhyj6108.s[29]++;
            $rootScope.section = null;
        } else {
                cov_2oqhyj6108.b[1][1]++;
                cov_2oqhyj6108.s[30]++;
                if (state.name === 'program') {
                    cov_2oqhyj6108.b[2][0]++;
                    cov_2oqhyj6108.s[31]++;

                    $rootScope.showSecondaryNavigation = true;
                    cov_2oqhyj6108.s[32]++;
                    $rootScope.menuBackgroundColor = 'white';
                    cov_2oqhyj6108.s[33]++;
                    $rootScope.menuTextColor = 'black';
                    cov_2oqhyj6108.s[34]++;
                    $rootScope.backButton = false;
                    cov_2oqhyj6108.s[35]++;
                    $rootScope.section = null;
                } else {
                        cov_2oqhyj6108.b[2][1]++;
                        cov_2oqhyj6108.s[36]++;
                        if (state.name === 'press') {
                            cov_2oqhyj6108.b[3][0]++;
                            cov_2oqhyj6108.s[37]++;

                            $rootScope.showSecondaryNavigation = false;
                            cov_2oqhyj6108.s[38]++;
                            $rootScope.menuBackgroundColor = 'white';
                            cov_2oqhyj6108.s[39]++;
                            $rootScope.menuTextColor = 'black';
                            cov_2oqhyj6108.s[40]++;
                            $rootScope.backButton = false;
                            cov_2oqhyj6108.s[41]++;
                            $rootScope.section = 'imprensa';
                        } else {
                                cov_2oqhyj6108.b[3][1]++;
                                cov_2oqhyj6108.s[42]++;
                                if (state.name === 'companies') {
                                    cov_2oqhyj6108.b[4][0]++;
                                    cov_2oqhyj6108.s[43]++;

                                    $rootScope.showSecondaryNavigation = false;
                                    cov_2oqhyj6108.s[44]++;
                                    $rootScope.menuBackgroundColor = 'white';
                                    cov_2oqhyj6108.s[45]++;
                                    $rootScope.menuTextColor = 'black';
                                    cov_2oqhyj6108.s[46]++;
                                    $rootScope.backButton = false;
                                    cov_2oqhyj6108.s[47]++;
                                    $rootScope.section = 'companhias';
                                } else {
                                        cov_2oqhyj6108.b[4][1]++;
                                        cov_2oqhyj6108.s[48]++;
                                        if (state.name === 'company') {
                                            cov_2oqhyj6108.b[5][0]++;
                                            cov_2oqhyj6108.s[49]++;

                                            $rootScope.showSecondaryNavigation = false;
                                            cov_2oqhyj6108.s[50]++;
                                            $rootScope.menuBackgroundColor = 'white';
                                            cov_2oqhyj6108.s[51]++;
                                            $rootScope.menuTextColor = 'black';
                                            cov_2oqhyj6108.s[52]++;
                                            $rootScope.backButton = true;
                                        } else {
                                                cov_2oqhyj6108.b[5][1]++;
                                                cov_2oqhyj6108.s[53]++;
                                                if (state.name === 'places') {
                                                    cov_2oqhyj6108.b[6][0]++;
                                                    cov_2oqhyj6108.s[54]++;

                                                    $rootScope.showSecondaryNavigation = false;
                                                    cov_2oqhyj6108.s[55]++;
                                                    $rootScope.menuBackgroundColor = 'white';
                                                    cov_2oqhyj6108.s[56]++;
                                                    $rootScope.menuTextColor = 'black';
                                                    cov_2oqhyj6108.s[57]++;
                                                    $rootScope.backButton = false;
                                                    cov_2oqhyj6108.s[58]++;
                                                    $rootScope.section = 'locais';
                                                } else {
                                                        cov_2oqhyj6108.b[6][1]++;
                                                        cov_2oqhyj6108.s[59]++;
                                                        if (state.name === 'project') {
                                                            cov_2oqhyj6108.b[7][0]++;
                                                            cov_2oqhyj6108.s[60]++;

                                                            $rootScope.showSecondaryNavigation = false;
                                                            cov_2oqhyj6108.s[61]++;
                                                            $rootScope.menuBackgroundColor = 'white';
                                                            cov_2oqhyj6108.s[62]++;
                                                            $rootScope.menuTextColor = 'black';
                                                            cov_2oqhyj6108.s[63]++;
                                                            $rootScope.backButton = false;
                                                            cov_2oqhyj6108.s[64]++;
                                                            $rootScope.section = 'projeto';
                                                        } else {
                                                                cov_2oqhyj6108.b[7][1]++;
                                                                cov_2oqhyj6108.s[65]++;
                                                                if (state.name === 'contacts') {
                                                                    cov_2oqhyj6108.b[8][0]++;
                                                                    cov_2oqhyj6108.s[66]++;

                                                                    $rootScope.showSecondaryNavigation = false;
                                                                    cov_2oqhyj6108.s[67]++;
                                                                    $rootScope.menuBackgroundColor = 'white';
                                                                    cov_2oqhyj6108.s[68]++;
                                                                    $rootScope.menuTextColor = 'black';
                                                                    cov_2oqhyj6108.s[69]++;
                                                                    $rootScope.backButton = false;
                                                                    cov_2oqhyj6108.s[70]++;
                                                                    $rootScope.section = 'contactos';
                                                                } else {
                                                                    cov_2oqhyj6108.b[8][1]++;
                                                                    cov_2oqhyj6108.s[71]++;

                                                                    $rootScope.menuBackgroundColor = 'white';
                                                                    cov_2oqhyj6108.s[72]++;
                                                                    $rootScope.menuTextColor = 'black';
                                                                    cov_2oqhyj6108.s[73]++;
                                                                    $rootScope.showSecondaryNavigation = false;
                                                                    cov_2oqhyj6108.s[74]++;
                                                                    $rootScope.backButton = false;
                                                                }
                                                            }
                                                    }
                                            }
                                    }
                            }
                    }
            }
    });
}
'use strict';

var cov_1ug0urz2k1 = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/sidebar/sidebar.js',
        hash = '6e11dbc4bf8aa94175aef4b5b0f52d32d72c6658',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/sidebar/sidebar.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1ug0urz2k1.s[0]++;
angular.module('app').component('sidebar', {
    templateUrl: 'app/components/sidebar/sidebar.html',
    bindings: {
        theme: '<'
    }
});
'use strict';

var cov_1py6fj49g1 = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/project/project.js',
        hash = '08998931168e6a030f6ec355129ffbc216605098',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/project/project.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 5,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1py6fj49g1.s[0]++;
angular.module('app').component('project', {
    templateUrl: 'app/components/project/project.html'
});
'use strict';

var cov_1wrx9w5ne4 = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/program/program.js',
        hash = 'd57074ac8ff8b67f1009e49f21e78146784f9085',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/program/program.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 27
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 36
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 40
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 20,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 49
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 14
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 9,
                        column: 62
                    },
                    end: {
                        line: 9,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 74
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProgramController = function () {
    ProgramController.$inject = ["$stateParams", "$rootScope", "$http"];
    function ProgramController($stateParams, $rootScope, $http) {
        _classCallCheck(this, ProgramController);

        cov_1wrx9w5ne4.f[0]++;
        cov_1wrx9w5ne4.s[0]++;

        this.$http = $http;
        cov_1wrx9w5ne4.s[1]++;
        this.lang = $rootScope.lang;
    }

    _createClass(ProgramController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            cov_1wrx9w5ne4.f[1]++;
            cov_1wrx9w5ne4.s[2]++;

            this.$http.get('events_' + this.lang + '.json').then(function (response) {
                cov_1wrx9w5ne4.f[2]++;
                cov_1wrx9w5ne4.s[3]++;

                _this.events = response.data;
            });
        }
    }]);

    return ProgramController;
}();

cov_1wrx9w5ne4.s[4]++;


angular.module('app').component('program', {
    templateUrl: 'app/components/program/program.html',
    controller: ProgramController
});
'use strict';

var cov_xilwg9b9j = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/press/press.js',
        hash = '103d2c09c87165974b0fd95e5503b524b4c2648e',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/press/press.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 97,
                    column: 10
                }
            },
            '2': {
                start: {
                    line: 101,
                    column: 0
                },
                end: {
                    line: 106,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 29
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 98,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PressController = function () {
    PressController.$inject = ["AppSettings"];
    function PressController(AppSettings) {
        _classCallCheck(this, PressController);

        cov_xilwg9b9j.f[0]++;
        cov_xilwg9b9j.s[0]++;

        this.AppSettings = AppSettings;
    }

    _createClass(PressController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_xilwg9b9j.f[1]++;
            cov_xilwg9b9j.s[1]++;

            this.items = [
            // 29 05 2018
            {
                image: '../assets/press/publico-29-05-2018.png',
                name: 'Público',
                date: '29.05.2018',
                url: 'https://www.publico.pt/2018/05/29/local/noticia/coliseu-ensaia-entrada-no-novo-circo-com-festival-internacional-1832598'
            }, {
                image: '../assets/press/portopt-29-05-2018.png',
                name: 'Porto.',
                date: '29.05.2018',
                url: 'http://www.porto.pt/noticias/festival-internacional-de-circo-traz-40-espetaculos-e-uma-grande-reflexao-sobre-o-futuro-desta-area-artistica'
            }, {
                image: '../assets/press/dn-29-05-2018.png',
                name: 'Diário de Notícias',
                date: '29.05.2018',
                url: 'https://www.dn.pt/lusa/interior/1o-festival-internacional-de-circo-do-porto-com-40-espetaculos-gratis-entre-13-e-16-de-setembro-9391081.html'
            }, {
                image: '../assets/press/timeout_29_05_2018.png',
                name: 'TimeOut',
                date: '29.05.2018',
                url: ' https://www.timeout.pt/porto/pt/noticias/coliseu-anuncia-o-i-festival-internacional-de-circo-do-porto-052918'
            },
            // 30 05 2018
            {
                image: '../assets/press/jpn-30-05-2018.png',
                name: 'jpn',
                date: '30.05.2018',
                url: 'https://jpn.up.pt/2018/05/30/em-setembro-o-circo-invade-o-porto-com-mais-de-40-espetaculo-gratuitos/'
            }, {
                image: '../assets/press/expresso-30-05-2018.png',
                name: 'Expresso',
                date: '30.05.2018',
                url: 'http://expresso.sapo.pt/cultura/2018-05-30-O-novo-circo-vai-chegar-ao-Coliseu-do-Porto'
            }, {
                image: '../assets/press/jn-30-05-2018.png',
                name: 'Jornal Notícias',
                date: '30.05.2018',
                url: this.AppSettings.appUrl + '/assets/press/jn.pdf'
            },
            // 31 05 2018
            {
                image: '../assets/press/porto_canal-31-05-2018.png',
                name: 'Porto Canal',
                date: '31.05.2018',
                url: 'http://portocanal.sapo.pt/noticia/156683'
            },
            // 05 06 2018
            {
                image: '../assets/press/rr-05-06-2018.png',
                name: 'Rádio Renascença',
                date: '05.06.2018',
                url: 'http://rr.sapo.pt/noticia/114977/o-circo-vai-ao-porto-ao-coliseu-claro-mas-tambem-as-ruas-da-cidade'
            }, {
                image: '../assets/press/jn_online_20-08-2018.png',
                name: 'Jornal Notícias',
                date: '20.08.2018',
                url: 'https://www.jn.pt/local/videos/interior/o-espetaculo-de-circo-que-nasce-no-bonfim-e-faz-palco-no-coliseu-9706284.html'
            }, {
                image: '../assets/press/tsf_31-08-2018.png',
                name: 'TSF',
                date: '31.08.2018',
                url: 'https://www.tsf.pt/cultura/interior/ate-fazem-tremer-as-pedras-da-calcada-9785505.html'
            }, {
                image: '../assets/press/publico_06-09-2018.png',
                name: 'Público',
                date: '06.09.2018',
                url: 'https://www.publico.pt/2018/09/06/local/noticia/jardins-e-pracas-do-porto-recebem-primeiro-festival-internacional-de-circo-1843238'
            }, {
                image: '../assets/press/rtp_14-09-2018.png',
                name: 'RTP',
                date: '14.09.2018',
                url: 'https://www.rtp.pt/noticias/cultura/porto-recebe-festival-internacional-de-circo_v1098870'
            }, {
                image: '../assets/press/publico_16-09-2018.png',
                name: 'Público',
                date: '16.09.2018',
                url: 'https://www.publico.pt/2018/09/16/local/noticia/o-novo-circo-saiu-do-coliseu-para-ocupar-quatro-pracas-do-porto-1844235'
            }];
        }
    }]);

    return PressController;
}();

cov_xilwg9b9j.s[2]++;


angular.module('app').component('press', {
    templateUrl: 'app/components/press/press.html',
    controller: PressController
});
'use strict';

var cov_2k8u20askg = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/mobileHeader/mobileHeader.js',
        hash = 'f0649feb5086bbcde831ac4f29515a153433d397',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/mobileHeader/mobileHeader.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2k8u20askg.s[0]++;
angular.module('app').component('mobileHeader', {
    templateUrl: 'app/components/mobileHeader/mobileHeader.html',
    bindings: {
        theme: '<'
    }
});
'use strict';

var cov_miwvqpizn = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/places/places.js',
        hash = 'ceccaefbbc09f2a735c62f1628765ee1b5c2fa96',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/places/places.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 5,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_miwvqpizn.s[0]++;
angular.module('app').component('places', {
    templateUrl: 'app/components/places/places.html'
});
'use strict';

var cov_1enuh1yl4x = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/menu/menu.js',
        hash = 'c9b3d0575847cef9fe91b251ef2b4fb9e4991d22',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/menu/menu.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 5,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1enuh1yl4x.s[0]++;
angular.module('app').component('menu', {
    templateUrl: 'app/components/menu/menu.html'
});
'use strict';

var cov_1vx16w5aaa = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/home/home.js',
        hash = '5406ae5a6f537cdd11ad43e22c3d4fad226bf2ea',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/home/home.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 16
                },
                end: {
                    line: 4,
                    column: 17
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 28
                },
                end: {
                    line: 20,
                    column: 9
                }
            },
            '2': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 34
                }
            },
            '3': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 21
                }
            },
            '4': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 16
                }
            },
            '5': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 27,
                    column: 16
                },
                end: {
                    line: 27,
                    column: 22
                }
            },
            '7': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 29,
                    column: 38
                }
            },
            '8': {
                start: {
                    line: 34,
                    column: 0
                },
                end: {
                    line: 39,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 27
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 24,
                        column: 18
                    },
                    end: {
                        line: 24,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 24
                    },
                    end: {
                        line: 30,
                        column: 9
                    }
                },
                line: 24
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 26,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 26,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                }, {
                    start: {
                        line: 26,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                }],
                line: 26
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeController = function HomeController($interval) {
    var _this = this;

    _classCallCheck(this, HomeController);

    cov_1vx16w5aaa.f[0]++;

    var i = (cov_1vx16w5aaa.s[0]++, 0);
    var backgrounds = (cov_1vx16w5aaa.s[1]++, ['../assets/home/3d-hmb-saolazaro.jpg', '../assets/home/le_fin_demain-zirkus_morsa-poveiros.jpg', '../assets/home/six_pieds_sur_terre-lapsus_coliseu.jpg', '../assets/home/sol_bemol-dirque_et_fien-santo_ildefonso.jpg', '../assets/home/viva_victor-krak-poveiros.jpg', '../assets/home/bruit_de_couloir-clement_dazin-batalha.jpg', '../assets/home/calcada.jpg', '../assets/home/chemins.jpg', '../assets/home/ducreux.jpg', '../assets/home/marimbondo.jpg', '../assets/home/mavara.jpg', '../assets/home/nicolas_joubard.jpg', '../assets/home/rouge.jpg', '../assets/home/the_rat_pack.jpg']);

    cov_1vx16w5aaa.s[2]++;
    this.img = backgrounds[0];

    cov_1vx16w5aaa.s[3]++;
    $interval(function () {
        cov_1vx16w5aaa.f[1]++;
        cov_1vx16w5aaa.s[4]++;

        i++;
        cov_1vx16w5aaa.s[5]++;
        if (i === backgrounds.length) {
            cov_1vx16w5aaa.b[0][0]++;
            cov_1vx16w5aaa.s[6]++;

            i = 0;
        } else {
            cov_1vx16w5aaa.b[0][1]++;
        }
        cov_1vx16w5aaa.s[7]++;
        _this.img = backgrounds[i];
    }, 1000 * 5);
};
HomeController.$inject = ["$interval"];

cov_1vx16w5aaa.s[8]++;


angular.module('app').component('home', {
    templateUrl: 'app/components/home/home.html',
    controller: HomeController
});
'use strict';

var cov_1vqgbghwva = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/footer/footer.js',
        hash = 'f8d5768ee9f91a8f5e071d2d441893e12fea7f98',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/footer/footer.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 5,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1vqgbghwva.s[0]++;
angular.module('app').component('footer', {
    templateUrl: 'app/components/footer/footer.html'
});
'use strict';

var cov_pijmvus1o = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/feed/feed.js',
        hash = 'd1f4b086d380564e68835a283fbfa02c035ce337',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/feed/feed.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 11
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 12
                },
                end: {
                    line: 9,
                    column: 13
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 16
                },
                end: {
                    line: 6,
                    column: 31
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 16
                },
                end: {
                    line: 8,
                    column: 31
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 79,
                    column: 10
                }
            },
            '5': {
                start: {
                    line: 83,
                    column: 0
                },
                end: {
                    line: 88,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 34
                    },
                    end: {
                        line: 80,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 4,
                        column: 22
                    },
                    end: {
                        line: 4,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 4,
                        column: 28
                    },
                    end: {
                        line: 10,
                        column: 9
                    }
                },
                line: 4
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 9,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 9,
                        column: 13
                    }
                }, {
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 9,
                        column: 13
                    }
                }],
                line: 5
            },
            '1': {
                loc: {
                    start: {
                        line: 5,
                        column: 16
                    },
                    end: {
                        line: 5,
                        column: 48
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 5,
                        column: 16
                    },
                    end: {
                        line: 5,
                        column: 30
                    }
                }, {
                    start: {
                        line: 5,
                        column: 34
                    },
                    end: {
                        line: 5,
                        column: 48
                    }
                }],
                line: 5
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeedController = function FeedController($mdMedia, $scope) {
    var _this = this;

    _classCallCheck(this, FeedController);

    cov_pijmvus1o.f[0]++;
    cov_pijmvus1o.s[0]++;

    $scope.$watch(function () {
        cov_pijmvus1o.f[1]++;
        cov_pijmvus1o.s[1]++;

        if ((cov_pijmvus1o.b[1][0]++, $mdMedia('sm')) || (cov_pijmvus1o.b[1][1]++, $mdMedia('md'))) {
            cov_pijmvus1o.b[0][0]++;
            cov_pijmvus1o.s[2]++;

            _this.limit = 2;
        } else {
            cov_pijmvus1o.b[0][1]++;
            cov_pijmvus1o.s[3]++;

            _this.limit = 3;
        }
    });

    cov_pijmvus1o.s[4]++;
    this.items = [{
        text: 'Os primeiros dias do Festival Internacional de Circo do Porto foram um malabarismo de emoções. Hoje, este evento dedicado ao circo contemporâneo despede-se do público, do Coliseu e da cidade. Mas ainda há muitos e bons espetáculos para ver esta tarde.',
        date: '16 Setembro',
        link: 'https://www.facebook.com/events/190206221807904/permalink/291177795044079/'
    }, {
        text: 'Depois do maravilhoso "Speakeasy", este sábado às 21h30, e domingo às 17h30, o Coliseu recebe o espetáculo "Six Pieds Sur Terre", da companhia Lapsus.',
        date: '15 Setembro',
        link: 'https://www.facebook.com/events/190206221807904/permalink/290651391763386/'
    }, {
        text: 'Gostava de fazer uma visita guiada ao Coliseu? A propósito do Festival Internacional de Circo do Porto, a casa do Circo por excelência da cidade do Porto vai estar a fazer visitas guiadas gratuitas.',
        date: '14 Setembro',
        link: 'https://www.facebook.com/events/190206221807904/permalink/289937801834745/'
    }, {
        text: 'Começa hoje o I Festival Internacional de Circo do Porto! Estes são os espetáculos gratuitos que pode ver esta quinta-feira.',
        date: '13 Setembro',
        link: 'https://www.facebook.com/events/190206221807904/permalink/289410241887501/'
    }, {
        text: 'As companhias The Rat Pack e d\'irque & fien já chegaram ao Coliseu! Atuam já esta quinta-feira, no primeiro dia do FIC Porto.',
        date: '12 Setembro',
        link: 'https://www.facebook.com/events/190206221807904/permalink/289026158592576/'
    }, {
        text: 'Os nossos programas, com sinopses, horários e palcos, já estão espalhados pelo Coliseu e por vários espaços da cidade. Agarre o seu.',
        date: '12 Setembro',
        link: 'https://www.facebook.com/events/190206221807904/permalink/288930861935439/'
    }, {
        text: 'Depois de já ter revelado 8 companhias, o Coliseu Porto Ageas anuncia agora o programa completo! Ao todo, vão passar pelo I Festival Internacional de Circo do Porto 13 companhias, 44 espetáculos, uma conferência internacional e apresentações diárias do Circo Social.',
        date: '06 Setembro',
        link: 'https://www.facebook.com/events/190206221807904/permalink/285428265619032/'
    }, {
        text: 'O Jornal de Notícias viu, em primeira mão, um ensaio do espetáculo que o Circo Social vai estrear no Festival Internacional de Circo do Porto. Hoje há uma Aula Aberta, às 22h00.',
        date: '31 Agosto',
        link: 'https://www.facebook.com/events/190206221807904/permalink/281876042640921/'
    }, {
        text: 'O Circo Social vai fazer uma Aula Aberta esta sexta-feira, 31 de agosto, às 22h00, junto à Igreja do Bonfim. O convite foi feito pela Junta de Freguesia do Bonfim, a propósito das Festas de Santa Clara.',
        date: '29 Agosto',
        link: 'https://www.facebook.com/events/190206221807904/permalink/280647676097091/'
    }, {
        text: 'Falta menos de um mês para o início do I Festival Internacional de Circo do Porto. Uma das 13 companhias que poderemos ver chega de França, chama-se Lapsus e é fruto da amizade de seis artistas que frequentaram juntos a École de Cirque de Lyon.',
        date: '28 Agosto',
        link: 'https://www.facebook.com/events/190206221807904/permalink/280169202811605/'
    }, {
        text: 'Falta um mês para vermos o Novo Circo nas ruas do Porto e no Coliseu! A STCP - Sociedade de Transportes Colectivos do Porto, SA e a CP - Comboios de Portugal são parceiros de divulgação e darão toda a informação sobre a melhor forma de chegar aos espetáculos.',
        date: '14 Agosto',
        link: 'https://www.facebook.com/events/190206221807904/permalink/266081427553716/'
    }, {
        text: 'Para além dos espetáculos espalhados pela cidade, o Festival vai apresentar mais duas componentes importantes. Uma delas será a Conferência Internacional, um espaço de discussão e literacia para o novo circo e o estado da arte em Portugal e na Europa.',
        date: '31 Julho',
        link: 'https://www.facebook.com/events/190206221807904/permalink/249881092507083/'
    }, {
        text: 'Faltam precisamente dois meses para o início do Festival Internacional de Circo do Porto. E faltam apenas alguns dias para divulgarmos mais um nome que vai fazer parte  do cartaz!',
        date: '13 Julho',
        link: 'https://www.facebook.com/events/190206221807904/permalink/229798561182003/'
    }];
};
FeedController.$inject = ["$mdMedia", "$scope"];

cov_pijmvus1o.s[5]++;


angular.module('app').component('feed', {
    templateUrl: 'app/components/feed/feed.html',
    controller: FeedController
});
'use strict';

var cov_1tuxa7208w = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/contacts/contacts.js',
        hash = 'dab1715ab7a9ed13dd88ee6ab1f67116f5c03803',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/contacts/contacts.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 5,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1tuxa7208w.s[0]++;
angular.module('app').component('contacts', {
    templateUrl: 'app/components/contacts/contacts.html'
});
'use strict';

var cov_11951egp6k = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/company/company.js',
        hash = 'f1ceda8b6bf56f1e5c0095e8b946a5757f125468',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/company/company.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 38
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 27
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 36
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 32
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 18,
                    column: 15
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 16
                },
                end: {
                    line: 17,
                    column: 17
                }
            },
            '7': {
                start: {
                    line: 14,
                    column: 20
                },
                end: {
                    line: 14,
                    column: 42
                }
            },
            '8': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 11
                }
            },
            '9': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 15
                }
            },
            '10': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 17
                }
            },
            '11': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 52
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 0
                },
                end: {
                    line: 37,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 49
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 14
                    },
                    end: {
                        line: 29,
                        column: 5
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 65
                    },
                    end: {
                        line: 11,
                        column: 66
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 77
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 34
                    },
                    end: {
                        line: 12,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 44
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                },
                line: 12
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 62
                    },
                    end: {
                        line: 21,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 74
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 21
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 22,
                        column: 34
                    },
                    end: {
                        line: 22,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 44
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                },
                line: 22
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                }, {
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 23,
                        column: 16
                    },
                    end: {
                        line: 25,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 23,
                        column: 16
                    },
                    end: {
                        line: 25,
                        column: 17
                    }
                }, {
                    start: {
                        line: 23,
                        column: 16
                    },
                    end: {
                        line: 25,
                        column: 17
                    }
                }],
                line: 23
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompanyController = function () {
    CompanyController.$inject = ["$stateParams", "$rootScope", "$http"];
    function CompanyController($stateParams, $rootScope, $http) {
        _classCallCheck(this, CompanyController);

        cov_11951egp6k.f[0]++;
        cov_11951egp6k.s[0]++;

        this.slug = $stateParams.slug;
        cov_11951egp6k.s[1]++;
        this.$http = $http;
        cov_11951egp6k.s[2]++;
        this.lang = $rootScope.lang;
        cov_11951egp6k.s[3]++;
        this.presentations = [];
    }

    _createClass(CompanyController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            cov_11951egp6k.f[1]++;
            cov_11951egp6k.s[4]++;

            this.$http.get('companies_' + this.lang + '.json').then(function (response) {
                cov_11951egp6k.f[2]++;
                cov_11951egp6k.s[5]++;

                response.data.forEach(function (record) {
                    cov_11951egp6k.f[3]++;
                    cov_11951egp6k.s[6]++;

                    if (record.slug === _this.slug) {
                        cov_11951egp6k.b[0][0]++;
                        cov_11951egp6k.s[7]++;

                        _this.company = record;
                        //this.company.presentation = record.presentation[this.lang];
                        // this.company.synopsis = record.synopsis[this.lang];
                    } else {
                        cov_11951egp6k.b[0][1]++;
                    }
                });
            });

            cov_11951egp6k.s[8]++;
            this.$http.get('events_' + this.lang + '.json').then(function (response) {
                cov_11951egp6k.f[4]++;
                cov_11951egp6k.s[9]++;

                response.data.forEach(function (record) {
                    cov_11951egp6k.f[5]++;
                    cov_11951egp6k.s[10]++;

                    if (record.slug === _this.slug) {
                        cov_11951egp6k.b[1][0]++;
                        cov_11951egp6k.s[11]++;

                        _this.presentations.push(record);
                    } else {
                        cov_11951egp6k.b[1][1]++;
                    }
                });
            });
        }
    }]);

    return CompanyController;
}();

cov_11951egp6k.s[12]++;


angular.module('app').component('company', {
    templateUrl: 'app/components/company/company.html',
    controller: CompanyController
});
'use strict';

var cov_17byfj4fo1 = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/components/companies/companies.js',
        hash = 'a980292bd8bebe4deff5f5362be70c302584c91d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/components/companies/companies.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 27
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 36
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 0
                },
                end: {
                    line: 21,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 49
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 14
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 9,
                        column: 65
                    },
                    end: {
                        line: 9,
                        column: 66
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 77
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompaniesController = function () {
    CompaniesController.$inject = ["$stateParams", "$rootScope", "$http"];
    function CompaniesController($stateParams, $rootScope, $http) {
        _classCallCheck(this, CompaniesController);

        cov_17byfj4fo1.f[0]++;
        cov_17byfj4fo1.s[0]++;

        this.$http = $http;
        cov_17byfj4fo1.s[1]++;
        this.lang = $rootScope.lang;
    }

    _createClass(CompaniesController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            cov_17byfj4fo1.f[1]++;
            cov_17byfj4fo1.s[2]++;

            this.$http.get('companies_' + this.lang + '.json').then(function (response) {
                cov_17byfj4fo1.f[2]++;
                cov_17byfj4fo1.s[3]++;

                _this.companies = response.data;
            });
        }
    }]);

    return CompaniesController;
}();

cov_17byfj4fo1.s[4]++;


angular.module('app').component('companies', {
    templateUrl: 'app/components/companies/companies.html',
    controller: CompaniesController
});
'use strict';

var cov_147x1hjhug = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/translations/en.js',
        hash = '38b340ee147971b7ca22bd848cedf2aa0f98c035',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/translations/en.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 5,
                    column: 4
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 3,
                    column: 9514
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 49
                    },
                    end: {
                        line: 1,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 75
                    },
                    end: {
                        line: 5,
                        column: 1
                    }
                },
                line: 1
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_147x1hjhug.s[0]++;
angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
    cov_147x1hjhug.f[0]++;
    cov_147x1hjhug.s[1]++;

    /* jshint -W100 */
    gettextCatalog.setStrings('en', { "Acreditamos que este novo festival se consubstanciará como um marco decisivo para a dinamização do Circo na cidade, complementando e valorizando o trabalho que, quer o próprio Coliseu Porto, quer outras entidades, vêm desenvolvendo há muitos anos.": "We are certain this new festival represents the decisive milestone towards the boosting of Circus in town, as to complement and value the work that Coliseu Porto, as well as other entities have carried on for many years.", "Apoio Financeiro da União Europeia | 152 942,71 €": "Financial support from the European Union | 152 942,71 € ", "Apresentações": "Presentations", "Após um período de desenvolvimento de uma matriz conceptual para o projeto, com a consultoria artística do artista João Paulo Santos, foi elaborada uma proposta de programação que integra criadores e artistas internacionais de indiscutível valia, num modelo de programação que propõe uma abordagem às linguagens e técnicas do Circo Contemporâneo, colocando-o em diálogo com as expressões mais tradicionais desta disciplina.": "Following the development of a conceptual matrix for the project, with the artistic consultancy by artist João Paulo Santos, a proposed programming has been prepared. This activating strategy includes renowned international creative and performing artists, with presentations and techniques about the language of Contemporary Circus, combined with traditional circus manifestations.", "Casa do Circo por excelência, o Coliseu começou a pensar num ambicioso projeto de Novo Circo em 2015. No ano seguinte, começou a ser desenhada a candidatura, apresentada em maio de 2016 à CCDR-N, em parceria com a Porto Lazer, Empresa de Desporto e Lazer do Município do Porto.": "Home to Circus, quintessentially, Coliseu started to envisage an ambitious New Circus project in 2015, on the celebrations of the 75th anniversary of Coliseu Porto. The following year, the application presented in May 2016 to CCDR-N, jointly with Porto Lazer, Porto Municipal Company, began to emerge.", "Companhias": "Companies", "Contactos": "Contacts", "Contribuir para a qualificação do acolhimento turístico na cidade.": "Add to the quality of tourist welcome in the city.", "Contribuir para o desenvolvimento social e humano, utilizando a cultura e as artes circenses como elemento central de uma atuação focada na geração de oportunidades de ascensão pessoal e coletiva para crianças e jovens.": "Add to the social and human development, highlighting the role of culture and\nCircus arts as key elements for generating opportunities of individual and collective growth both for children and young people;", "Custo Total Elegível | 179 932,60 €": "Total eligible cost | 179 932,60 €", "Código do Projeto: NORTE-14-2016-03": "Project Code: NORTE-14-2016-03", "Data de Aprovação | 27/10/2017": "Date of approval: 27/10/2017", "Data de Conclusão | 30/11/2018": "End date: 30/11/2018", "Data de Início | 01/01/2017": "Start date: 01/01/2017", "Descarregar programa.": "Download programme.", "Designação do Projeto: Festival Internacional de Circo | Coliseu Porto": "Project Name: Festival Internacional de Circo | Coliseu Porto", "Entidade Beneficiária: Associação Amigos do Coliseu do Porto": "Beneficiary entity: Associação Amigos do Coliseu do Porto", "Entrada Livre": "Free Entrance", "Este projeto integra uma programação artística de referência, bem como um programa de Circo Social e uma conferência internacional, capazes de, em conjunto, reforçar o posicionamento estratégico do Coliseu e da cidade do Porto como expoentes máximos do Circo em Portugal. Terá lugar no Coliseu Porto, Praça da Batalha, Praça dos Poveiros, Jardim de S. Lázaro e Largo de Santo Ildefonso.": "Thus, was born the Porto International Circus Festival, a seminal artistic programme with over 40 free entry performances to be held in Coliseu, Batalha Square, Poveiros Square, S. Lázaro Garden and in Santo Ildefonso Plaza, between 13 and 16 September 2018. The programme also includes a Social Circus project and an international conference. Altogether, these actions are intended to stimulate the strategic positioning of Coliseu and the city of Porto as top leaders of Circus in Portugal.", "Ficha Técnica": "Technical Info", "Imprensa": "Press", "Locais": "Venues", "Melhorar a oferta turística da cidade em termos de programação cultural, potenciando a relação com os espaços públicos da cidade, colmatando défices de qualificação;": "Improve the quality of tourism offer in the city, relating to cultural programming, optimising the city’s public spaces by alleviating eligibility deficits;", "Novidades": "Updates", "O Festival Internacional de Circo do Porto tem como ambição a valorização do Circo enquanto disciplina artística de excelência, posicionando internacionalmente o Porto como lugar de criação e acolhimento das melhores expressões desta arte e, simultaneamente, contribuir para a criação e desenvolvimento de novos públicos para a arte e a cultura.": "Porto International Circus Festival’s vision is the enhancement of Circus as an activity of artistic excellence, globally engaging Porto as a creative and gathering place of the best expressions of this art, whilst contributing to the creation and development of new audiences in art and culture.", "O Festival Internacional de Circo | Coliseu Porto é cofinanciado pelo NORTE 2020, no âmbito do Portugal 2020, através do Fundo Europeu de Desenvolvimento Regional (FEDER).": "The International Circus Festival | Coliseu Porto is cofinanced by NORTE 2020, in the framework of Portugal 2020, through the European Regional Development Fund (ERDF)", "Objetivo Principal: A conservação, proteção, promoção e o desenvolvimento do património natural e cultural": "Main Objective: Preservation, protection, promotion and development of the cultural and natural heritage", "Objetivos Gerais:": "General Objectives:", "Objetivos específicos": "Specific objectives", "Para a prossecução desta ambição foi constituída uma equipa de projeto experiente e profissional que garante os níveis de qualidade que o Coliseu pretende ver cumpridos para o projeto, ao nível artístico e de produção, com a coordenação geral do presidente do Coliseu, Eduardo Paz Barroso. A estratégia de programação é caracterizada por um equilíbrio entre o circo clássico e a vertente contemporânea: um circo baseado numa linguagem atual e inovadora que integra disciplinas artísticas como o equilibrismo, acrobacia, trapézio, malabarismo, trampolim, aéreo de tecidos e fitas, quick change, rola-rola e clown, apelando também a diálogos com outras disciplinas artísticas como a música, o teatro, a performance, o vídeo ou as artes digitais.": "A team has been created to achieving this ambition; a professional and experienced team that ensures the high-quality standards that Coliseu intends to see fulfilled regarding this project, both in the artistic and production levels, with the general coordination of the President of the Coliseu, Eduardo Paz Barroso. The programming strategy is marked by a balance between traditional and contemporary circus, based on a current and innovative language that covers several artistic subjects such as balancing acts, acrobatics, trapeze, juggling, trampoline, flying trapeze, ribbon trapeze, quick change, rola-rola and clown, in conjunction with other artistic subjects, including music, theatre, performance, video or digital arts.", "Para assuntos de imprensa": "For press affairs", "Posicionar o Porto, através da conferência internacional a acontecer durante o festival, como um local de discussão e literacia para o Novo Circo.": "Position Porto, through the international conference that will be held in the festival, as a literacy and debate venue regarding the New Circus", "Potenciar a experiência a visitantes e turistas através das atividades de mediação cultural;": "Foster visitors and tourists experience through cultural activities;", "Programa": "Programme", "Projeto": "Project", "Promover a aproximação das populações locais ao circo através de plataformas colaborativas de experimentação e de aprendizagem, fomentando a criação de novos públicos para esta e para outras áreas artísticas e culturais;": "Promote local communities’ rapprochement to circus via experimentation and learning collaborative platforms, fostering the creation of new audiences, for this and other artistic and cultural areas;", "Promover um novo Festival Internacional de Circo na cidade do Porto, com a marca do Coliseu Porto, em associação com a PortoLazer;": "Promote a new International Circus Festival in the city of Porto, with the brand name Coliseu Porto, jointly with PortoLazer;", "Proporcionar um programa cultural qualificado, diversificado de cariz internacional que sinalize o Porto, nacional e internacionalmente, como palco do que melhor se produz contemporaneamente na área do circo;": "Deliver a qualified, diverse and international cultural programme, flagging the city, both at national and international levels, as home to the best contemporary circus manifestations;", "Reforçar a notoriedade internacional do Porto enquanto destino cultural de eleição;": "Strengthen Porto’s international prestige as a cultural destination of choice;", "Reforçar e renovar a notoriedade, local e regional, da tradição da programação de circo;": "Revamp and reinforce the local and regional prestige of circus programming;", "Região de Intervenção: Norte": "Intervention area: North", "Sinopse do Espectáculo": "Synopsis", "Telefone:": "Phone", "Texto de Apresentação": "Presentation" });
    /* jshint +W100 */
}]);
'use strict';

var cov_25g20is1hn = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/app/shared/htmlToText.filter.js',
        hash = '87e31b6d8e3a320b97e34bfb24fb30f504480368',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/app/shared/htmlToText.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 14,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 69
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 14,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'htmlToText',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 26
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 31
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 19
                    },
                    end: {
                        line: 11,
                        column: 68
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 11,
                        column: 26
                    },
                    end: {
                        line: 11,
                        column: 63
                    }
                }, {
                    start: {
                        line: 11,
                        column: 66
                    },
                    end: {
                        line: 11,
                        column: 68
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_25g20is1hn.s[0]++;
(function () {
    'use strict';

    cov_25g20is1hn.f[0]++;
    cov_25g20is1hn.s[1]++;
    angular.module('app').filter('htmlToText', htmlToText);

    /* @ngInject */
    function htmlToText() {
        cov_25g20is1hn.f[1]++;
        cov_25g20is1hn.s[2]++;

        return function (text) {
            cov_25g20is1hn.f[2]++;
            cov_25g20is1hn.s[3]++;

            return text ? (cov_25g20is1hn.b[0][0]++, String(text).replace(/<[^>]+>/gm, '')) : (cov_25g20is1hn.b[0][1]++, '');
        };
    }
})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/companies/companies.html","<!-- companies -->\n<div style=\"padding-top: 60px; background-color: #FFFFFF\">\n\n    <!-- mobile version -->\n\n    <div ng-repeat=\"company in $ctrl.companies\" layout=\"column\" hide-gt-xs>\n        <div class=\"companies-company-block company-image\" style=\"background-image: url(\'{{company.image}}\'); border-bottom-color: {{$root.theme.dark}}\">\n            <a ui-sref=\"company({slug: company.slug})\" style=\"text-decoration: none\">\n                <div layout=\"column\" layout-align=\"end start\" style=\"height: 100%\">\n                    <p class=\"company-country\">{{company.country}}</p>\n                    <p class=\"company-name\">{{company.name}}</p>\n                    <p class=\"company-show\">{{company.show}}</p>\n                </div>\n            </a>\n        </div>\n    </div>\n\n    <!-- desktop version -->\n\n    <div ng-repeat=\"company in $ctrl.companies\" layout=\"row\" layout-align=\"start stretch\" hide-xs>\n        <div flex=\"65\" flex-offset=\"5\" class=\"companies-company-block\" style=\"border-bottom-color: {{$root.theme.dark}}\">\n            <p class=\"company-country\">{{company.country}}</p>\n            <p class=\"company-name\"><a ui-sref=\"company({slug: company.slug})\">{{company.name}}</a></p>\n            <p class=\"company-presentation\">{{company.presentation|limitTo:200 }} ...</p>\n        </div>\n        <div flex=\"25\" class=\"company-image\" style=\"background-image: url(\'{{company.image}}\'); border-bottom-color: {{$root.theme.dark}}\">\n        </div>\n    </div>\n</div>\n\n<footer></footer>\n");
$templateCache.put("app/components/company/company.html","<!-- facebook -->\n<meta view-head property=\"og:site_name\" content=\"Festival Internacional de Circo do Porto\">\n<meta view-head property=\"og:url\" content=\"https://circo.coliseu.pt/companhia/{{::$ctrl.company.slug}}\">\n<meta view-head property=\"og:type\" content=\"article\">\n<meta view-head property=\"og:title\" content=\"{{::$ctrl.company.name}}\">\n<meta view-head property=\"og:description\" content=\"{{$ctrl.company.presentation | htmlToText}}\">\n<meta view-head property=\"og:image\" content=\"https://circo.coliseu.pt/{{::$ctrl.company.social_image.substring(3);}}\">\n<meta view-head property=\"og:image:width\" content=\"{{::$ctrl.company.social_image_width}}\">\n<meta view-head property=\"og:image:height\" content=\"{{::$ctrl.company.social_image_height}}\">\n\n<!-- twitter -->\n<meta view-head name=\"twitter:card\" content=\"summary_large_image\">\n<meta view-head name=\"twitter:title\" content=\"{{::$ctrl.company.name}}\">\n<meta view-head name=\"twitter:description\" content=\"{{$ctrl.company.presentation | htmlToText | limitTo: 100}}\">\n<meta view-head name=\"twitter:image\" content=\"https://circo.coliseu.pt/{{::$ctrl.company.social_image.substring(3)}}\">\n\n<!-- company -->\n\n<div style=\"padding-top: 60px; background-color: #FFFFFF\" layout=\"column\">\n    <div flex-offset=\"5\" flex=\"90\">\n        <div class=\"company-company-block\">\n            <p class=\"company-country\">{{$ctrl.company.country}}</p>\n            <p class=\"company-name\">{{$ctrl.company.name}}</p>\n            <p class=\"company-section-title\" translate>Texto de Apresentação</p>\n            <p class=\"company-presentation\">{{$ctrl.company.presentation}}</p>\n            <p class=\"company-section-title\" translate>Sinopse do Espectáculo</p>\n            <p class=\"company-presentation\">{{$ctrl.company.synopsis}}</p>\n            <p class=\"company-section-title\" translate>Apresentações</p>\n            <p ng-repeat=\"presentation in $ctrl.presentations\">\n                {{presentation.date}} • {{presentation.time}} • {{presentation.venue}}\n            </p>\n            <p class=\"company-section-title\" translate>Ficha Técnica</p>\n            <p class=\"company-presentation\">{{$ctrl.company.technical}}</p>\n            <p></p>\n        <div hide-gt-xs>\n            <youtube-video video-url=\"$ctrl.company.video\" player-width=\"\'90%\'\"></youtube-video>\n        </div>\n        <div hide-xs>\n            <youtube-video video-url=\"$ctrl.company.video\"></youtube-video>\n        </div>\n    </div>\n</div>\n\n<footer></footer>\n</div>");
$templateCache.put("app/components/contacts/contacts.html","<div style=\"padding-top: 60px; background-color: #FFFFFF\" layout=\"row\" layout-align=\"center center\" class=\"contacts\">\n    <div flex=\"90\">\n        <h2>Coliseu Porto Ageas</h2>\n        <p><b translate>Telefone:</b> (351) 223 394 940</p>\n        <p><b>E-mail:</b> <a href=\"mailto:&#099;&#111;&#108;&#105;&#115;&#101;&#117;&#064;&#099;&#111;&#108;&#105;&#115;&#101;&#117;&#046;&#112;&#116;\">&#099;&#111;&#108;&#105;&#115;&#101;&#117;&#064;&#099;&#111;&#108;&#105;&#115;&#101;&#117;&#046;&#112;&#116;</a></p>\n        <p><span translate>Para assuntos de imprensa</span>: <a href=\"mailto:&#115;&#097;&#114;&#097;&#046;&#099;&#111;&#101;&#108;&#104;&#111;&#064;&#099;&#111;&#108;&#105;&#115;&#101;&#117;&#046;&#112;&#116;\">&#115;&#097;&#114;&#097;&#046;&#099;&#111;&#101;&#108;&#104;&#111;&#064;&#099;&#111;&#108;&#105;&#115;&#101;&#117;&#046;&#112;&#116;</a></p>\n    </div>\n</div>\n");
$templateCache.put("app/components/feed/feed.html","<div class=\"feed-wrapper\">\n    <div class=\"feed-header\" style=\"background-color: {{$root.theme.dark}}\">\n        <h1 translate>Novidades</h1>\n    </div>\n    <div class=\"feed-container\" style=\"background-color: {{$root.theme.light}}\">\n        <div class=\"feed-item\" style=\"border-bottom-color: {{$root.theme.dark}}\">\n            <p class=\"feed-item-text\"><a href=\"https://drive.google.com/file/d/19F6pJwgt_WK6Mv2jr32eFJKhuUyLkAgG\" target=\"_blank\"><b>Disponível para consulta a Publicação Final sobre o I Festival Internacional de Circo do Porto</b>.</a></p>\n            <p class=\"feed-item-datetime\">30 Novembro</p>\n        </div>\n        <div class=\"feed-item\" style=\"border-bottom-color: {{$root.theme.dark}}\" ng-repeat=\"item in $ctrl.items | limitTo:$ctrl.limit\">\n            <p class=\"feed-item-text\"><a href=\"{{item.link}}\" target=\"_blank\">{{item.text}}</a></p>\n            <p class=\"feed-item-datetime\">{{item.date}}</p>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/footer/footer.html","<!-- mobile version -->\n\n<div class=\"footer\" style=\"background-color: {{$root.theme.dark}}\" layout=\"column\" hide-gt-xs>\n    <img src=\"../assets/logos/apoios-ficp-03.png\">\n    <img src=\"../assets/logos/apoios-ficp-01.png\">\n    <img src=\"../assets/logos/apoios-ficp-02.png\">\n</div>\n\n<!-- desktop version -->\n\n<div class=\"footer\" layout=\"row\" layout-align=\"space-between center\" flex=\"90\" flex-offset=\"5\" hide-xs>\n    <img flex=\"30\" src=\"../assets/logos/apoios-ficp-01_p.png\">\n    <img flex=\"30\" src=\"../assets/logos/apoios-ficp-02_p.png\">\n    <img flex=\"30\" src=\"../assets/logos/apoios-ficp-03_p.png\">\n</div>\n");
$templateCache.put("app/components/home/home.html","<!-- facebook -->\n<meta view-head property=\"og:site_name\" content=\"Festival Internacional de Circo do Porto\">\n<meta view-head property=\"og:url\" content=\"https://circo.coliseu.pt/\">\n<meta view-head property=\"og:type\" content=\"article\">\n<meta view-head property=\"og:title\" content=\"Festival Internacional de Circo do Porto\">\n<meta view-head property=\"og:description\" content=\"De 13 e 16 de setembro, o Coliseu Porto oferece ao público de todas as idades mais de 40 espetáculos gratuitos de novo circo, nas praças e jardins da Baixa e, claro, no chapitô da cidade, o Coliseu.\">\n<meta view-head property=\"og:image\" content=\"https://circo.coliseu.pt/assets/images/ficp-coliseu_porto.jpg\">\n<meta view-head property=\"og:image:width\" content=\"650\">\n<meta view-head property=\"og:image:height\" content=\"949\">\n\n<!-- twitter -->\n<meta view-head name=\"twitter:card\" content=\"summary_large_image\">\n<meta view-head name=\"twitter:title\" content=\"Festival Internacional de Circo do Porto\">\n<meta view-head name=\"twitter:description\" content=\"De 13 e 16 de setembro, o Coliseu Porto oferece ao público de todas as idades mais de 40 espetáculos gratuitos de novo circo, nas praças e jardins da Baixa e, claro, no chapitô da cidade, o Coliseu.\">\n<meta view-head name=\"twitter:image\" content=\"https://circo.coliseu.pt/assets/images/ficp-coliseu_porto.jpg\">\n\n\n\n<!-- versão mobile -->\n<div class=\"home-background\" style=\"background-image: url(\'{{$ctrl.img}}\')\" hide show-xs></div>\n<feed hide show-xs></feed>\n<footer hide show-xs></footer>\n\n<!-- versão desktop -->\n<div layout=\"column\" class=\"home-background\" style=\"background-image: url(\'{{$ctrl.img}}\')\" layout-align=\"space-between center\" hide show-gt-xs>\n    <div></div>\n    <div layout=\"row\" layout-align=\"space-around center\" style=\"margin-bottom: 15px\">\n        <img flex=\"30\" src=\"../assets/logos/apoios-ficp-01.png\">\n        <img flex=\"30\" src=\"../assets/logos/apoios-ficp-02.png\">\n        <img flex=\"30\" src=\"../assets/logos/apoios-ficp-03.png\">\n    </div>\n</div>\n");
$templateCache.put("app/components/menu/menu.html","<div class=\"menu\">\n    <nav layout=\"row\" hide show-gt-xs>\n        <div flex=\"90\" flex-offset=\"5\" layout=\"row\" layout-align=\"space-between center\">\n            <div class=\"menu-item\">\n                <a ui-sref=\"program()\" ng-click=\"$root.filter = {}\" ui-sref-active=\"current\" ng-class=\"{\'menu-no-text-shadow\': $root.menuBackgroundColor == \'white\', \'menu-text-shadow\': $root.menuBackgroundColor != \'white\'}\">\n                    <span translate>Programa</span></a>\n            </div>\n            <div class=\"menu-item\">\n                <a ui-sref=\"companies()\" ui-sref-active=\"current\" ng-class=\"{\'menu-no-text-shadow\': $root.menuBackgroundColor == \'white\', \'menu-text-shadow\': $root.menuBackgroundColor != \'white\'}\">\n                    <span translate>Companhias</span></a>\n            </div>\n            <div class=\"menu-item\">\n                <a ui-sref=\"places()\" ui-sref-active=\"current\" ng-class=\"{\'menu-no-text-shadow\': $root.menuBackgroundColor == \'white\', \'menu-text-shadow\': $root.menuBackgroundColor != \'white\'}\">\n                    <span translate>Locais</span></a>\n            </div>\n            <div class=\"menu-item\"><a ui-sref=\"project()\" ui-sref-active=\"current\" ng-class=\"{\'menu-no-text-shadow\': $root.menuBackgroundColor == \'white\', \'menu-text-shadow\': $root.menuBackgroundColor != \'white\'}\">\n                <span translate>Projeto</span></a>\n            </div>\n            <div class=\"menu-item\"><a ui-sref=\"press()\" ui-sref-active=\"current\" ng-class=\"{\'menu-no-text-shadow\': $root.menuBackgroundColor == \'white\', \'menu-text-shadow\': $root.menuBackgroundColor != \'white\'}\">\n                <span translate>Imprensa</span></a></div>\n            <div class=\"menu-item\"><a ui-sref=\"contacts()\" ui-sref-active=\"current\" ng-class=\"{\'menu-no-text-shadow\': $root.menuBackgroundColor == \'white\', \'menu-text-shadow\': $root.menuBackgroundColor != \'white\'}\">\n                <span translate>Contactos</span></a></div>\n\n            <div class=\"menu-item\"><a href=\"#\" style=\"cursor: pointer; position: relative; color: {{$root.menuTextColor}}\" ng-click=\"$root.changeLang()\">\n                <!-- <span ng-if=\"$root.lang == \'pt\'\">[English]<span class=\"soon\">Soon</span></span> -->\n                <span ng-if=\"$root.lang == \'pt\'\">[English]</span>\n                <span ng-if=\"$root.lang == \'en\'\">[Português]</span>\n            </a></div>\n        </div>\n    </nav>\n</div>\n\n<nav layout=\"row\" hide show-gt-xs ng-if=\"$root.showSecondaryNavigation\" style=\"margin-top: 20px\">\n    <div flex=\"90\" flex-offset=\"5\" layout=\"row\" layout-align=\"space-between center\">\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {date: \'13.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'13.09\'}\">13.09</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {date: \'14.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'14.09\'}\">14.09</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {date: \'15.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'15.09\'}\">15.09</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {date: \'16.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'16.09\'}\">16.09</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {venue: \'COLISEU PORTO\'}\" ng-class=\"{\'active\': $root.filter.venue == \'COLISEU PORTO\'}\">COLISEU PORTO</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {venue: \'SANTO ILDEFONSO\'}\" ng-class=\"{\'active\': $root.filter.venue == \'SANTO ILDEFONSO\'}\">SANTO ILDEFONSO</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {venue: \'PRAÇA BATALHA\'}\" ng-class=\"{\'active\': $root.filter.venue == \'PRAÇA BATALHA\'}\">PRAÇA BATALHA</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {venue: \'PRAÇA POVEIROS\'}\" ng-class=\"{\'active\': $root.filter.venue == \'PRAÇA POVEIROS\'}\">PRAÇA POVEIROS</a>\n        <a href=\"#\" class=\"secondary-nav-item\" ng-click=\"$root.filter = {venue: \'SÃO LÁZARO\'}\" ng-class=\"{\'active\': $root.filter.venue == \'SÃO LÁZARO\'}\">SÃO LÁZARO</a>\n    </div>\n</nav>\n\n<nav flex=\"90\" flex-offset=\"5\" ng-show=\"$root.backButton\" style=\"margin-top: 20px; margin-bottom: -20px\">\n    <a ng-click=\"$root.goBack()\" style=\"cursor: pointer\">\n        <md-icon style=\"color: #CCCCCC\">arrow_back</md-icon>\n    </a>\n</nav>\n");
$templateCache.put("app/components/mobileHeader/mobileHeader.html","<div style=\"background-color: {{$ctrl.theme}}\" layout=\"column\" hide-gt-xs>\n\n    <!-- mobile menu -->\n\n    <div ng-if=\"$root.menuOpen\" class=\"mobile-menu-overlay\">\n    </div>\n\n    <div ng-if=\"$root.menuOpen\" class=\"mobile-menu\">\n        <a href=\"#\" ng-click=\"$root.menuOpen = !$root.menuOpen\">\n            <md-icon class=\"mobile-menu-close\" ng-click=\"$root.hideScroll = false;\">close</md-icon>\n        </a>\n        <div>\n            <div class=\"mobile-menu-item\"><a ui-sref=\"home\">Início</a></div>\n            <div class=\"mobile-menu-item\"><a ui-sref=\"program\" ng-click=\"$root.filter = {}\" translate>Programa</a></div>\n            <div class=\"mobile-menu-item\"><a ui-sref=\"companies\" translate>Companhias</a></div>\n            <div class=\"mobile-menu-item\"><a ui-sref=\"places\" translate>Locais</a></div>\n            <div class=\"mobile-menu-item\"><a ui-sref=\"project\" translate>Projeto</a></div>\n            <div class=\"mobile-menu-item\"><a ui-sref=\"press\" translate>Imprensa</a></div>\n            <div class=\"mobile-menu-item\"><a ui-sref=\"contacts\" translate>Contactos</a></div>\n            <div class=\"mobile-menu-item\">\n                <a ui-sref=\"#\" ng-click=\"$root.changeLang()\">\n                    <span ng-if=\"$root.lang == \'pt\'\">[English]</span>\n                    <span ng-if=\"$root.lang == \'en\'\">[Português]</span>\n                </a>\n            </div>\n        </div>\n    </div>\n\n    <!-- end mobile menu -->\n\n    <div class=\"brand\" layout=\"column\" layout-align=\"space-between start\">\n        <div layout=\"row\" style=\"width: 100%\" layout-align=\"space-between start\">\n            <h1>\n                <a ui-sref=\"home()\">Festival<br>Internacional<br>de Circo do Porto</a>\n            </h1>\n            <div>\n                <md-icon class=\"mobile-menu-menu\" ng-click=\"$root.menuOpen = true; $root.hideScroll = true\">menu</md-icon>\n            </div>\n        </div>\n        <h2 ng-if=\"$root.fullHeader\">13.09. - <br>\n            16.09.2018\n        </h2>\n\n        <div layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%; padding-bottom: 20px\" ng-if=\"$root.fullHeader\">\n            <h3>Entrada Livre</h3>\n\n            <div layout=\"row\" layout-align=\"center center\">\n                <a target=\"_blank\" href=\"https://www.facebook.com/events/190206221807904/?active_tab=discussion\" class=\"social-icon icon-facebook-with-circle\" style=\"outline: none\"> </a>\n                <a target=\"_blank\" href=\"https://www.instagram.com/coliseuporto/\" class=\"social-icon icon-instagram-with-circle\" style=\"outline: none\"> </a>\n                <a target=\"_blank\" href=\"https://twitter.com/ColiseuPorto\" class=\"social-icon icon-twitter-with-circle\" style=\"outline: none\"></a>\n            </div>\n        </div>\n    </div>\n    <div ng-if=\"!$root.fullHeader\">\n        &nbsp;\n    </div>\n    <div class=\"mobile-section-header\" ng-if=\"$root.section\">\n        <h1>{{$root.section}}</h1>\n    </div>\n</div>\n\n<div ng-if=\"$root.showSecondaryNavigation\" hide-gt-xs>\n    <div layout=\"row\">\n        <div flex=\"50\" class=\"sec-nav-block\" ng-click=\"$ctrl.filterType = \'date\'\">\n            <p style=\"cursor: pointer\">Datas</p>\n        </div>\n        <div flex=\"50\" class=\"sec-nav-block\" ng-click=\"$ctrl.filterType = \'venue\'\">\n            <p style=\"cursor: pointer\">Locais</p>\n        </div>\n    </div>\n</div>\n\n<div class=\"filter-wrapper\" ng-if=\"$root.showSecondaryNavigation && $ctrl.filterType == \'date\'\" layout=\"row\" layout-align=\"space-around center\">\n    <div>\n        <a href=\"#\" class=\"filter-link date\" ng-click=\"$root.filter = {date: \'13.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'13.09\'}\">13.09</a>\n    </div>\n    <div>\n        <a href=\"#\" class=\"filter-link date\" ng-click=\"$root.filter = {date: \'14.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'14.09\'}\">14.09</a>\n    </div>\n    <div>\n        <a href=\"#\" class=\"filter-link date\" ng-click=\"$root.filter = {date: \'15.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'15.09\'}\">15.09</a>\n    </div>\n    <div>\n        <a href=\"#\" class=\"filter-link date\" ng-click=\"$root.filter = {date: \'16.09\'}\" ng-class=\"{\'active\': $root.filter.date == \'16.09\'}\">16.09</a>\n    </div>\n</div>\n\n<div class=\"filter-wrapper\" ng-if=\"$root.showSecondaryNavigation && $ctrl.filterType == \'venue\'\" layout=\"row\" layout-align=\"space-around center\">\n    <div class=\"filter-block\">\n        <a href=\"#\" class=\"filter-link venue\" ng-click=\"$root.filter = {venue: \'COLISEU PORTO\'}\" ng-class=\"{\'active\': $root.filter.venue == \'COLISEU PORTO\'}\">COLISEU PORTO</a>\n    </div>\n    <div class=\"filter-block\">\n        <a href=\"#\" class=\"filter-link venue\" ng-click=\"$root.filter = {venue: \'SANTO ILDEFONSO\'}\" ng-class=\"{\'active\': $root.filter.venue == \'SANTO ILDEFONSO\'}\">SANTO ILDEFONSO</a>\n    </div>\n    <div class=\"filter-block\">\n        <a href=\"#\" class=\"filter-link venue\" ng-click=\"$root.filter = {venue: \'PRAÇA BATALHA\'}\" ng-class=\"{\'active\': $root.filter.venue == \'PRAÇA BATALHA\'}\">PRAÇA BATALHA</a>\n    </div>\n    <div class=\"filter-block\">\n        <a href=\"#\" class=\"filter-link venue\" ng-click=\"$root.filter = {venue: \'PRAÇA POVEIROS\'}\" ng-class=\"{\'active\': $root.filter.venue == \'PRAÇA POVEIROS\'}\">PRAÇA POVEIROS</a>\n    </div>\n    <div class=\"filter-block\">\n        <a href=\"#\" class=\"filter-link venue\" ng-click=\"$root.filter = {venue: \'SÃO LÁZARO\'}\" ng-class=\"{\'active\': $root.filter.venue == \'SÃO LÁZARO\'}\">SÃO LÁZARO</a>\n    </div>\n</div>\n\n");
$templateCache.put("app/components/press/press.html","<div style=\"padding-top: 60px; background-color: #FFFFFF\" layout=\"row\">\n    <div layout=\"row\" style=\"flex-wrap: wrap\" flex=\"90\" flex-offset=\"5\">\n        <div flex-gt-xs=\"50\" flex-gt-sm=\"33\" ng-repeat=\"item in $ctrl.items\" class=\"clip-wrapper\">\n            <a href=\"{{item.url}}\" target=\"_blank\">\n                <img src=\"{{item.image}}\" class=\"press-clipping\">\n            </a>\n            <p class=\"publication-title\">{{item.name}}</p>\n            <p class=\"publication-date\">{{item.date}}</p>\n        </div>\n    </div>\n</div>\n\n<footer></footer>\n");
$templateCache.put("app/components/places/places.html","<iframe src=\"https://www.google.com/maps/d/embed?mid=1Bv6-qf0tiUk61-WFRjGsDrplP6mCKO_O\" width=\"100%\" height=\"100%\" frameborder=\"0\" style=\"border:0\" allowfullscreen=\"\"></iframe>\n");
$templateCache.put("app/components/program/program.html","<!-- mobile version -->\n\n<div layout=\"row\" layout-align=\"center center\" hide-gt-xs>\n    <p><a class=\"disclaimer\" href=\"https://drive.google.com/file/d/1NvIPbLwOVX2kgNJYlAvLysagfTle2803/view?usp=sharing\" target=\"_blank\"><span translate>Descarregar programa.</span></a></p>\n</div>\n<div ng-repeat=\"event in $ctrl.events | filter:$root.filter\" layout=\"column\" hide-gt-xs>\n    <div class=\"event-block event-image\" style=\"background-image: url(\'{{event.image}}\'); border-bottom-color: {{$root.theme.dark}}\">\n        <div layout=\"column\" layout-align=\"end start\" style=\"height: 100%\">\n            <p class=\"event-time-place\">{{event.date}} • {{event.time}} • {{event.venue}}</p>\n            <p class=\"event-name\">{{event.name}}</p>\n            <p class=\"event-company\"><a ui-sref=\"company({slug:event.slug})\">{{event.company}}</a></p>\n        </div>\n    </div>\n</div>\n\n<!-- desktop version -->\n\n<div style=\"padding-top: 100px; background-color: #FFF\" hide-xs>\n    <div layout=\"row\" flex-offset=\"5\">\n        <p><a class=\"disclaimer\" href=\"https://drive.google.com/file/d/1NvIPbLwOVX2kgNJYlAvLysagfTle2803/view?usp=sharing\" target=\"_blank\"><span translate>Descarregar programa.</span></a></p>\n    </div>\n    <div ng-repeat=\"event in $ctrl.events | filter:$root.filter\" layout=\"row\" layout-align=\"start stretch\">\n        <div flex=\"65\" flex-offset=\"5\" class=\"event-block\" style=\"border-bottom-color: {{$root.theme.dark}}\">\n            <p class=\"event-time-place\">{{event.date}} • {{event.time}} • {{event.venue}}</p>\n            <p class=\"event-name\">{{event.name}}</p>\n            <p class=\"event-company\"><a ui-sref=\"company({slug:event.slug})\">{{event.company}}</a></p>\n            <p class=\"event-description\">&nbsp;</p>\n        </div>\n        <div flex=\"25\" class=\"event-image\" style=\"background-image: url(\'{{event.image}}\'); border-bottom-color: {{$root.theme.dark}}\">\n        </div>\n    </div>\n</div>\n\n<footer></footer>\n");
$templateCache.put("app/components/project/project.html","<div style=\"padding-top: 60px; background-color: #FFFFFF\" layout=\"row\" layout-align=\"center center\">\n    <div flex=\"90\">\n        <p translate>Casa do Circo por excelência, o Coliseu começou a pensar num ambicioso projeto de Novo Circo em 2015. No ano seguinte, começou a ser desenhada a candidatura, apresentada em maio de 2016 à CCDR-N, em parceria com a Porto Lazer, Empresa de Desporto e Lazer do Município do Porto.</p>\n\n        <p translate>Este projeto integra uma programação artística de referência, bem como um programa de Circo Social e uma conferência internacional, capazes de, em conjunto, reforçar o posicionamento estratégico do Coliseu e da cidade do Porto como expoentes máximos do Circo em Portugal. Terá lugar no Coliseu Porto, Praça da Batalha, Praça dos Poveiros, Jardim de S. Lázaro e Largo de Santo Ildefonso.</p>\n\n        <p translate>O Festival Internacional de Circo do Porto tem como ambição a valorização do Circo enquanto disciplina artística de excelência, posicionando internacionalmente o Porto como lugar de criação e acolhimento das melhores expressões desta arte e, simultaneamente, contribuir para a criação e desenvolvimento de novos públicos para a arte e a cultura.</p>\n\n        <p translate>Para a prossecução desta ambição foi constituída uma equipa de projeto experiente e profissional que garante os níveis de qualidade que o Coliseu pretende ver cumpridos para o projeto, ao nível artístico e de produção, com a coordenação geral do presidente do Coliseu, Eduardo Paz Barroso. A estratégia de programação é caracterizada por um equilíbrio entre o circo clássico e a vertente contemporânea: um circo baseado numa linguagem atual e inovadora que integra disciplinas artísticas como o equilibrismo, acrobacia, trapézio, malabarismo, trampolim, aéreo de tecidos e fitas, quick change, rola-rola e clown, apelando também a diálogos com outras disciplinas artísticas como a música, o teatro, a performance, o vídeo ou as artes digitais.</p>\n\n        <p translate>Após um período de desenvolvimento de uma matriz conceptual para o projeto, com a consultoria artística do artista João Paulo Santos, foi elaborada uma proposta de programação que integra criadores e artistas internacionais de indiscutível valia, num modelo de programação que propõe uma abordagem às linguagens e técnicas do Circo Contemporâneo, colocando-o em diálogo com as expressões mais tradicionais desta disciplina.</p>\n\n        <p translate>Acreditamos que este novo festival se consubstanciará como um marco decisivo para a dinamização do Circo na cidade, complementando e valorizando o trabalho que, quer o próprio Coliseu Porto, quer outras entidades, vêm desenvolvendo há muitos anos.</p>\n\n\n        <p><b translate>Objetivos Gerais:</b></p>\n        <ul>\n            <li translate>Reforçar a notoriedade internacional do Porto enquanto destino cultural de eleição;</li>\n            <li translate>Contribuir para a qualificação do acolhimento turístico na cidade.</li>\n        </ul>\n\n        <p><b translate>Objetivos específicos</b></p>\n        <ul>\n            <li translate>Promover um novo Festival Internacional de Circo na cidade do Porto, com a marca do Coliseu Porto, em associação com a PortoLazer;</li>\n            <li translate>Reforçar e renovar a notoriedade, local e regional, da tradição da programação de circo;</li>\n            <li translate>Proporcionar um programa cultural qualificado, diversificado de cariz internacional que sinalize o Porto, nacional e internacionalmente, como palco do que melhor se produz contemporaneamente na área do circo;</li>\n            <li translate>Melhorar a oferta turística da cidade em termos de programação cultural, potenciando a relação com os espaços públicos da cidade, colmatando défices de qualificação;</li>\n            <li translate>Potenciar a experiência a visitantes e turistas através das atividades de mediação cultural;</li>\n            <li translate>Promover a aproximação das populações locais ao circo através de plataformas colaborativas de experimentação e de aprendizagem, fomentando a criação de novos públicos para esta e para outras áreas artísticas e culturais;</li>\n            <li translate>Posicionar o Porto, através da conferência internacional a acontecer durante o festival, como um local de discussão e literacia para o Novo Circo.</li>\n            <li translate>Contribuir para o desenvolvimento social e humano, utilizando a cultura e as artes circenses como elemento central de uma atuação focada na geração de oportunidades de ascensão pessoal e coletiva para crianças e jovens.</li>\n        </ul>\n\n        <p translate>O Festival Internacional de Circo | Coliseu Porto é cofinanciado pelo NORTE 2020, no âmbito do Portugal 2020, através do Fundo Europeu de Desenvolvimento Regional (FEDER).</p>\n\n        <ul>\n            <li translate>Designação do Projeto: Festival Internacional de Circo | Coliseu Porto</li>\n            <li translate>Código do Projeto: NORTE-14-2016-03</li>\n            <li translate>Objetivo Principal: A conservação, proteção, promoção e o desenvolvimento do património natural e cultural</li>\n            <li translate>Região de Intervenção: Norte</li>\n            <li translate>Entidade Beneficiária: Associação Amigos do Coliseu do Porto</li>\n        </ul>\n\n        <ul>\n            <li translate>Data de Aprovação | 27/10/2017</li>\n            <li translate>Data de Início | 01/01/2017</li>\n            <li translate>Data de Conclusão | 30/11/2018</li>\n            <li translate>Custo Total Elegível | 179 932,60 €</li>\n            <li translate>Apoio Financeiro da União Europeia | 152 942,71 €</li>\n        </ul>\n    </div>\n</div>\n\n<footer></footer>\n");
$templateCache.put("app/components/sidebar/sidebar.html","<div class=\"sidebar\" style=\"background-color: {{$ctrl.theme}}\" layout=\"column\">\n    <div class=\"brand\" flex=\"45\" layout=\"column\" layout-align=\"start start\">\n        <h1>\n            <a ui-sref=\"home()\">Festival<br>Internacional<br>de Circo do Porto</a>\n        </h1>\n        <h2>13.09. - <br>\n            16.09.2018\n        </h2>\n        <h3 translate>Entrada Livre</h3>\n\n        <div class=\"social-block\" layout=\"row\" layout-align=\"center center\">\n            <a target=\"_blank\" href=\"https://www.facebook.com/events/190206221807904/?active_tab=discussion\" class=\"social-icon icon-facebook-with-circle\"> </a>\n            <a target=\"_blank\" href=\"https://www.instagram.com/coliseuporto/\" class=\"social-icon icon-instagram-with-circle\"> </a>\n            <a target=\"_blank\" href=\"https://twitter.com/ColiseuPorto\" class=\"social-icon icon-twitter-with-circle\"></a>\n        </div>\n    </div>\n    <feed flex=\"55\">\n</feed></div>\n");}]);
'use strict';

var cov_j7kl5ck85 = function () {
    var path = '/home/lobo/repos/festival-circo-porto/src/routes.js',
        hash = 'e1de5a7f7d541f981a563e15e67c43bf11b2a045',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/festival-circo-porto/src/routes.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 26
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 7,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 4
                },
                end: {
                    line: 8,
                    column: 38
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 4
                },
                end: {
                    line: 42,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: 'routesConfig',
                decl: {
                    start: {
                        line: 6,
                        column: 9
                    },
                    end: {
                        line: 6,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 77
                    },
                    end: {
                        line: 43,
                        column: 1
                    }
                },
                line: 6
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_j7kl5ck85.s[0]++;
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    cov_j7kl5ck85.f[0]++;
    cov_j7kl5ck85.s[1]++;

    $locationProvider.html5Mode(true).hashPrefix('!');
    cov_j7kl5ck85.s[2]++;
    $urlRouterProvider.otherwise('/');

    cov_j7kl5ck85.s[3]++;
    $stateProvider.state('home', {
        url: '/',
        template: '<home/>'
    }).state('program', {
        url: '/programa',
        template: '<program/>'
    }).state('companies', {
        url: '/companhias',
        template: '<companies/>'
    }).state('company', {
        url: '/companhia/:slug',
        template: '<company/>'
    }).state('places', {
        url: '/locais',
        template: '<places/>'
    }).state('project', {
        url: '/projeto',
        template: '<project/>'
    }).state('press', {
        url: '/imprensa',
        template: '<press/>'
    }).state('contacts', {
        url: '/contactos',
        template: '<contacts/>'
    });
}